module.exports = __webpack_public_path__ + "static/media/warzone2.ce724a10.webp";